export const enum ProductTypeConstant {
  PRODUCT = 'PRODUCT',
  KIT = 'KIT',
}

export enum ProductTypes {
  PRODUCT = 'PRODUCT',
  KIT = 'KIT',
}
